<ng-template #input>
	<div class="btn-group btn-group-toggle" [formControl]="control" ngbRadioGroup>
		<label class="btn-primary" ngbButtonLabel *ngFor="let option of options">
			<input type="radio" ngbButton [value]="option"> {{option}}
		</label>
	</div>
</ng-template>

<ng-template #vertical>
	<div class="input-group col align-items-center">
		<label [for]="id" class="font-weight-600 text-left col-12 p-0">{{label}}</label>

		<div class="input-wrapper col-12 p-0">
			<ng-container *ngTemplateOutlet="input"></ng-container>
		</div>
	</div>
</ng-template>

<ng-container *transloco="let t">
	<div class="input-group row"
		 *ngIf="template === ControlTemplate.horizontal else vertical">
		<label [for]="id" class="font-weight-600 text-right col-3">{{label}}</label>
		<div class="input-wrapper col-9">
			<ng-container *ngTemplateOutlet="input"></ng-container>
		</div>
	</div>

	<ng-container *ngIf="control.touched">
		<div [ngClass]="{'control-errors-vertical': template === ControlTemplate.vertical}"
			 class="control-errors col-12" *ngFor="let error of control.errors | keyvalue">
			<span class="error">{{ t('generic.'+error.key) }}</span>
		</div>
	</ng-container>
</ng-container>

